module.exports = __webpack_public_path__ + "images/bootstrap/glyphicons-halflings.png";